import api from 'api/apiInstance';

export const resendMagicLink = (path: string) => ({
  POST: ({ code, matterId, inviteeEmail } : any) => api.post(path, { code, matterId, inviteeEmail })
});
